import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import {
  CreateDashboardQRCode,
  GetDashboardQRCodes
} from "helpers/api_method";

export const fetchQRCodes = createAsyncThunk(
  "qrGenerator/fetchQRCodes",
  async (_, { rejectWithValue }) => {
    try {
      const response: any = await GetDashboardQRCodes();
      if (response && (response.success || response.data)) {
        return response.data || [];
      }
      return rejectWithValue(response?.message || "Failed to load QR codes");
    } catch (error: any) {
      console.error("Error fetching QR codes:", error);
      return rejectWithValue(error?.message || "Failed to load QR codes");
    }
  }
);

export const createQRCode = createAsyncThunk(
  "qrGenerator/createQRCode",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await CreateDashboardQRCode(data);
      if (response && (response.success || response.data)) {
        toast.success("QR code saved");
        return response.data;
      }
      const message = response?.message || "Failed to save QR code";
      toast.error(message);
      return rejectWithValue(message);
    } catch (error: any) {
      const message = error?.message || "Failed to save QR code";
      console.error("Error creating QR code:", error);
      toast.error(message);
      return rejectWithValue(message);
    }
  }
);

